const MIN_PASSWORD = 12;

export function PasswordStrength({ length }: { readonly length: number }) {
  const level =
    length >= 25 ? "very-strong" :
    length >= 20 ? "strong" :
    length >= MIN_PASSWORD ? "medium" :
    "weak";

  const config = {
    weak: { label: `${length}/${MIN_PASSWORD} caractères`, color: "text-red-500", bar: "bg-red-500", width: "w-1/4" },
    medium: { label: "Correct", color: "text-amber-500", bar: "bg-amber-500", width: "w-2/4" },
    strong: { label: "Fort", color: "text-emerald-500", bar: "bg-emerald-500", width: "w-3/4" },
    "very-strong": { label: "Très fort", color: "text-emerald-600", bar: "bg-emerald-600", width: "w-full" },
  }[level];

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between">
        <span className="text-xs text-ink-muted">Sécurité</span>
        <span className={`text-xs font-medium ${config.color}`}>{config.label}</span>
      </div>
      <div className="h-1.5 bg-border rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-300 ${config.bar} ${config.width}`} />
      </div>
    </div>
  );
}
